import { render, staticRenderFns } from "./admissionExpensesDetail.vue?vue&type=template&id=42c18c82&scoped=true"
import script from "./admissionExpensesDetail.vue?vue&type=script&lang=js"
export * from "./admissionExpensesDetail.vue?vue&type=script&lang=js"
import style0 from "./admissionExpensesDetail.vue?vue&type=style&index=0&id=42c18c82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c18c82",
  null
  
)

export default component.exports